module.exports = __webpack_public_path__ + "img/theo-heuft3.7487dee0.jpg";